/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Loading_Usage_DataInputs */



/**
* | output |
* | --- |
* | "Loading usage data..." |
*
* @param {Dashboard_Loading_Usage_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_loading_usage_data = /** @type {((inputs?: Dashboard_Loading_Usage_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Loading_Usage_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lade Nutzungsdaten...")
	return /** @type {LocalizedString} */ ("Loading usage data...")
});